import logo from "./logo.svg";
import "./App.css";

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Ferreiro Apps</h1>
        <a href="mailto:apps.ferreiro@gmail.com" style={{ color: "white" }}>
          Contact us
        </a>
      </header>
    </div>
  );
}

export default Home;
